import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import brandLogo from "./../assets/brand.png";

const SecondFooter = () => {
  const getLanguageMessages = (language) => {
    switch (language) {
      case "en":
        return require("../lang/en.json");
      case "fr":
        return require("../lang/fr.json");
      case "es":
        return require("../lang/es.json");
      case "pt":
        return require("../lang/pt.json");
      default:
        return require("../lang/en.json");
    }
  };

  const selectedLanguage = useSelector((state) => state.language);
  
  // Footer link styling
  const linkStyle = {
    color: "#5D6D7E",
    textDecoration: "none",
    fontFamily: "'Montserrat', sans-serif",
    fontSize: "0.85rem",
    fontWeight: 500,
    marginLeft: "1.5rem",
    transition: "color 0.2s ease",
    letterSpacing: "0.2px"
  };

  return (
    <footer
      style={{ 
        width: "100%", 
        backgroundColor: "#f8f9fa", 
        borderTop: "1px solid #e0e0e0",
        padding: "20px 0"
      }}
    >
      <Container>
        <div className="row w-100 align-items-center">
          {/* Left side with logos */}
          <div className="col-md-6">
            <div className="d-flex align-items-center">
              <img 
                src={brandLogo} 
                alt="Verto Logo" 
                style={{ 
                  width: "130px",
                  height: "auto",
                  marginRight: "15px"
                }}
              />
            </div>
          </div>
          
          {/* Right side with links */}
          <div className="col-md-6 mt-3 mt-md-0">
            <div className="d-flex flex-wrap justify-content-md-end">
              <Link 
                to="/ethics" 
                style={linkStyle}
                onMouseOver={(e) => e.target.style.color = "#3498DB"}
                onMouseOut={(e) => e.target.style.color = "#5D6D7E"}
              >
                {getLanguageMessages(selectedLanguage).footerLinks.ethics}
              </Link>
              <Link 
                to="/terms" 
                style={linkStyle}
                onMouseOver={(e) => e.target.style.color = "#3498DB"}
                onMouseOut={(e) => e.target.style.color = "#5D6D7E"}
              >
                {getLanguageMessages(selectedLanguage).footerLinks.terms}
              </Link>
              <Link 
                to="/privacy" 
                style={linkStyle}
                onMouseOver={(e) => e.target.style.color = "#3498DB"}
                onMouseOut={(e) => e.target.style.color = "#5D6D7E"}
              >
                {getLanguageMessages(selectedLanguage).footerLinks.privacy}
              </Link>
              <Link 
                to="/press" 
                style={linkStyle}
                onMouseOver={(e) => e.target.style.color = "#3498DB"}
                onMouseOut={(e) => e.target.style.color = "#5D6D7E"}
              >
                {getLanguageMessages(selectedLanguage).footerLinks.press}
              </Link>
              <Link 
                to="/cookies-policy" 
                style={linkStyle}
                onMouseOver={(e) => e.target.style.color = "#3498DB"}
                onMouseOut={(e) => e.target.style.color = "#5D6D7E"}
              >
                {getLanguageMessages(selectedLanguage).footerLinks.cookiesPolicy}
              </Link>
            </div>
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default SecondFooter;